import { useMemo } from "react";
import { ISupportMessage } from "../../models/supportChatModels";
import { messageTextUtility } from "../../../../common/infrastructure/utilities/messageTextUtility";
import { getAvatarGradient, getInitials } from "../../../portal/myProfile/components/ProfileAvatar";

export const useSupportChatMessage = (message: ISupportMessage) => {
  const textParts = useMemo(
    () => messageTextUtility.splitLinks(messageTextUtility.toPlainText(message.content, message.sentAt)),
    [message.content, message.sentAt],
  );

  const nameParts = message.senderName.split(" ");
  const firstName = nameParts[0] ?? "";
  const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : undefined;

  return {
    textParts,
    initials: getInitials(firstName, lastName),
    gradient: getAvatarGradient(message.senderId),
  };
};
